import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("canvas", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "loadingContainerMobAtem" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "loadAnim",
    class: "loadAnim"
  })
], -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", null, _hoisted_3))
}